import { Status } from "../Config/Status.js";

const SmoothScroll = () => {
  const DOM = document.querySelectorAll(".js-scroll");
  DOM.forEach(elm => {
    const href = elm.getAttribute("href");
    const target = document.querySelector(href);
    elm.addEventListener("click", e => {
      e.preventDefault();
      const position = target.getBoundingClientRect().top + Status.scrollY;
      window.scrollTo({
        top: position,
        behavior: "smooth"
      });
    });
  });
}

export default SmoothScroll;